import { Link } from "react-router-dom";
import styled from "../styles";
import withMargin, { WithMarginProp } from "../styles/withMargin";
import withPadding, { WithPaddingProp } from "../styles/withPadding";
import { Chevron } from "./Chevron";
import { Flex } from "./Flex";
import { View } from "./View";

export const BackLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;

  font-weight: ${(p) => p.theme.typography.weight.semi};
  color: ${(p) => p.theme.color.typography.secondary};
  line-height: 1;

  margin-bottom: ${(p) => p.theme.spacing.xl};

  ${withMargin}
`;

export const FakeBackLink = styled.p`
  text-decoration: none;
  display: flex;
  align-items: center;

  font-weight: ${(p) => p.theme.typography.weight.semi};
  color: ${(p) => p.theme.color.typography.secondary};
  cursor: pointer;
  line-height: 1;

  margin-bottom: ${(p) => p.theme.spacing.xl};

  ${withMargin}
`;

export const BackIcon = styled(Link)<WithPaddingProp & WithMarginProp>`
  text-decoration: none;
  display: flex;
  border-radius: 999px;
  box-shadow: ${(p) => p.theme.shadow.imageFloatingIcon};
  justify-content: center;
  align-items: center;
  background: ${(p) => p.theme.color.card.background};
  border: 1px solid ${(p) => p.theme.color.card.divider};

  ${withMargin}
  ${withPadding}
`;

interface BackButtonWithTextProps extends WithMarginProp {
  to: string;
  text?: string;
}

interface FakeBackButtonWithTextProps extends WithMarginProp {
  onClick: () => void;
  text?: string;
}

export const BackLinkWithText: React.FC<BackButtonWithTextProps> = ({
  to,
  text = "Back",
  ...marginProps
}) => {
  return (
    <BackLink to={to} {...marginProps}>
      <Flex align="center" justify="center">
        <View margin="0 xs 0 0">
          <Chevron direction="left" />
        </View>
        <span style={{ marginTop: -2 }}>{text}</span>
      </Flex>
    </BackLink>
  );
};

export const FakeBackLinkWithText: React.FC<FakeBackButtonWithTextProps> = ({
  onClick,
  text = "Back",
  ...marginProps
}) => {
  return (
    <FakeBackLink onClick={onClick} {...marginProps}>
      <Flex align="center" justify="center">
        <View margin="0 xs 0 0">
          <Chevron direction="left" />
        </View>
        <span style={{ marginTop: -2 }}>{text}</span>
      </Flex>
    </FakeBackLink>
  );
};
